<template>
<div></div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  props: {
    // Determines whether the field is disabled
    disabled: {
      type: Boolean,
      default: false,
    },
    // A label to display as part of the input
    label: {
      type: String,
      default: "",
    },
    sorts: {
      type: Array,
      default: () => [],
      required: true,
    },
  },

  data() {
    return {
      sortSelected: "",
      name: "search-sorts",
      formattedSorts: [],
    };
  },

  mounted() {
    const sorts = [...this.sorts];

    // Create a new unique parameter called optionValue which includes the value (asc or desc) and title
    this.formattedSorts = sorts.map((sort) => ({
      ...sort,
      optionValue: `${sort.name}-${this.$capitalise(sort.value)}`,
    }));

    // If Use Query, Check the URL and see if there is a sort value
    let sortUrlValue = "";

    if (this.$cludo.useQuery) {
      sortUrlValue = this.$getSearchParameter(`sort`);
    }

    //If a sort value exist in the URL, priotise that as the default select value first
    if (sortUrlValue) {
      this.sortSelected = sortUrlValue;
      this.handleSelectChange();
    } else {
      // Check if the field selected has one of the options as true
      const selectedIndex = this.formattedSorts.findIndex(
        (el) => el.selected === true || el.selected === "true"
      );

      if (selectedIndex >= 0) {
        // this means there is a default option selected by user
        this.sortSelected = this.formattedSorts[selectedIndex].optionValue;
      }
    }
    this.vuexSetSortFilters(this.formattedSorts);
  },
  methods: {
    ...mapActions({
      vuexSetSortFilters: "cludo/setSortFilters",
    }),
    handleSelectChange() {
      // Retrieve the selected sort

      if (this.sortSelected) {
        const selectedSortIndex = this.formattedSorts.findIndex(
          (sort) => sort.optionValue === this.sortSelected
        );

        // Loop through sorts to make all options not selected
        this.formattedSorts.forEach((sort) => (sort.selected = false));

        // Make the selected option true
        if (selectedSortIndex > -1) {
          this.formattedSorts[selectedSortIndex].selected = true;
        }
      } else {
        // Default option is picked which should reset sort parameters to not selected
        this.formattedSorts.forEach((sort) => (sort.selected = false));
      }

      //Save sorts value to store
      this.vuexSetSortFilters(this.formattedSorts);
    },
  },
};
</script>
<style></style>
